<template>
  <b-modal
    id="create-customer-modal"
    title="Thêm khách hàng mới"
    @ok="onCreateCustomer"
    @hidden="resetForm"
  >
    <b-form-group
      label="Tên khách hàng"
      label-for="newCustomerName"
      class="required-control"
    >
      <b-form-input
        id="newCustomerName"
        v-model="customer.fullName"
        required
        :state="!!customer.fullName"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Số điện thoại"
      label-for="newCustomerPhone"
      class="required-control"
    >
      <b-form-input
        id="newCustomerPhone"
        v-model="customer.phoneNumber"
        required
        :state="isValidPhone"
      ></b-form-input>
      <b-form-invalid-feedback :state="isValidPhone">
        Vui lòng nhập số điện thoại hợp lệ
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Email" label-for="newCustomerEmail">
      <b-form-input
        id="newCustomerEmail"
        v-model="customer.email"
        type="email"
        :state="isValidEmail"
      ></b-form-input>
      <b-form-invalid-feedback :state="isValidEmail">
        Vui lòng nhập email hợp lệ
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Giới tính" label-for="newCustomerGender">
      <b-form-select
        id="newCustomerGender"
        v-model="customer.gender"
        value-field="value"
        required
        text-field="label"
        :options="genderOptions"
      ></b-form-select>
    </b-form-group>

    <b-form-group label="Địa chỉ" label-for="newCustomerAddress">
      <b-form-input
        id="newCustomerAddress"
        v-model="customer.address"
      ></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { makeToastFaile } from '@/utils/common';
import CustomerModel from '../../../posm/models/Customer.model';
import { handleApiError } from '../../../../../utils/errorHandler';

export default {
  name: 'CreateCustomerModal',
  data() {
    return {
      // Form
      customer: new CustomerModel(),

      // Options
      genderOptions: [
        { value: null, label: 'Chọn giới tính' },
        { value: 1, label: 'Nam' },
        { value: 2, label: 'Nữ' },
        { value: 3, label: 'Khác' },
      ],
    };
  },

  computed: {
    isValidPhone() {
      return this.customer.validatePhoneNumber();
    },

    isValidEmail() {
      if (!this.customer.email) return true;
      return this.customer.validateEmail();
    },
  },

  methods: {
    ...mapActions({
      createCustomer: 'customers/createCustomer',
    }),

    async onCreateCustomer(e) {
      e.preventDefault();

      if (
        !this.customer.fullName ||
        !this.isValidPhone ||
        !this.customer.gender
      ) {
        makeToastFaile('Vui lòng điền đầy đủ thông tin khách hàng');
        return;
      }

      try {
        const customer = await this.createCustomer(this.customer);
        this.$emit('created', customer);
        this.$bvModal.hide('create-customer-modal');
      } catch (error) {
        handleApiError(error);
      }
    },

    resetForm() {
      this.customer = new CustomerModel();
      this.$emit('hidden');
    },

    show(initialName = '') {
      this.customer.fullName = initialName;
      this.$bvModal.show('create-customer-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.required-control label::after {
  content: ' *';
  color: #f64e60;
}
</style>
